const fixturesActionTypes = {
  FETCH_ALL_FIXTURES_START: "FETCH_ALL_FIXTURES_START",
  FETCH_ALL_FIXTURES_SUCCESS: "FETCH_ALL_FIXTURES_SUCCESS",
  FETCH_ALL_FIXTURES_FAILURE: "FETCH_ALL_FIXTURES_FAILURE",

  FETCH_USER_FIXTURES_START: "FETCH_USER_FIXTURES_START",
  FETCH_USER_FIXTURES_SUCCESS: "FETCH_USER_FIXTURES_SUCCESS",
  FETCH_USER_FIXTURES_FAILURE: "FETCH_USER_FIXTURES_FAILURE",

  FETCH_CREATOR_FIXTURES_START: "FETCH_CREATOR_FIXTURES_START",
  FETCH_CREATOR_FIXTURES_SUCCESS: "FETCH_CREATOR_FIXTURES_SUCCESS",
  FETCH_CREATOR_FIXTURES_FAILURE: "FETCH_CREATOR_FIXTURES_FAILURE",

  FETCH_TOURNAMENT_FIXTURES_START: "FETCH_TOURNAMENT_FIXTURES_START",
  FETCH_TOURNAMENT_FIXTURES_SUCCESS: "FETCH_TOURNAMENT_FIXTURES_SUCCESS",
  FETCH_TOURNAMENT_FIXTURES_FAILURE: "FETCH_TOURNAMENT_FIXTURES_FAILURE",

  CLEAR_TOURNAMENT_FIXTURES: "CLEAR_TOURNAMENT_FIXTURES",
};

export default fixturesActionTypes;
